import {
    closeModalIconSvg,
    thanksContentIconSvg,
    thankYouEmailSvg, 
    thankYouHeartSvg, 
    thankYouPhoneSvg, 
    thankYouSuccessSvg,
    thankYouLoaderSvg
} from 'constants/svg-assets';

export const closeModalSvg = closeModalIconSvg;
export const thanksContentSvg = thanksContentIconSvg;
export const thankYouEmail = thankYouEmailSvg;
export const thankYouHeart = thankYouHeartSvg;
export const thankYouPhone = thankYouPhoneSvg;
export const thankYouSuccess = thankYouSuccessSvg;
export const thankYouLoader = thankYouLoaderSvg;
